import React from 'react';
import { map, get } from 'lodash';

import { entityInfoCellView as EntityInfoCellView } from 'ui/views/widgets/entityInfoCellView';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { entityInfoCells as EntityInfoCells } from 'ui/views/widgets/entityInfoCells';
 *
 * // render
 * <EntityInfoCells propName='propValue'/>
 */
export const entityInfoCells = ( props ) => {
    
    return (
        <div className='ui-entity-info-cells'>
            {
                map( props.items, section => {

                    return (
                        <EntityInfoCellView
                            key={ section.name }
                            item={ section }
                            value={ props.values[ section.name ] }
                            options={ get( props, `options[${ get( section, 'options', '' ) }]`, [] ) }
                            actionsVisibility={ props.actionsVisibility }
                            iconsVisibility={ props.iconsVisibility }
                            className={ props.className }
                            onActionClick={ props.onActionClick }
                            entityConfig={ props.entityConfig }
                            cellClassName= { props.cellClassName }
                        />
                    );
                } )
            }
        </div>
    );
};

// set display name
entityInfoCells.displayName = 'entityInfoCells';

// set default props
entityInfoCells.defaultProps = {};

// prop types
entityInfoCells.propTypes = {};
